import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }, values) => {
  commit(types.RELANCE_TOGGLE_LOADING);
  axios
    .get(URL_BACKEND + "api-relance/list/" + values.ligne_rob_id + "/")
    .then((response) => {
      commit(types.RELANCE_TOGGLE_LOADING);
      commit(types.RELANCE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.RELANCE_SET_ITEMS, []);
      commit(types.RELANCE_TOGGLE_LOADING);
      commit(types.RELANCE_SET_ERROR, e.message);
    });
};
